import banks from './cards.js'
import rewards from './rewards.js'
import leftPad from 'left-pad'

/**
 * Calculator javascript.
 * @author Dayne Coulson-Hoffacker
 */
export default class CalculateMyBonus {
  /**
   * Constructs a new counter component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.questions = this.element.queryAll('.single-question')
    this.firstPart = this.element.querySelector('.first-part')
    this.secondPart = this.element.querySelector('.second-part')
    this.firstPartSelect = this.firstPart.querySelector('select')
    this.secondPartSelect = this.secondPart.querySelector('select')
    this.firstPartEmptySpan = this.firstPart.querySelector('.empty')
    this.secondPartEmptySpan = this.secondPart.querySelector('.empty')
    this.question1 = this.element.querySelector('#question-1')
    this.question2 = this.element.querySelector('#question-2')
    this.formWrapper = this.element.querySelector('.form-wrapper')
    this.formInner = this.formWrapper.querySelector('.form-inner')
    this.calculateSubmitWrapper = this.element.querySelector('.calculator-submit')
    this.calculateSubmitBtn = this.calculateSubmitWrapper.querySelector('input[type="submit"]')
    this.humorousLine = this.element.querySelector('.humorous-line')
    this.plane = this.element.querySelector('.plane')
    this.sectionHeader = this.element.querySelector('header')
    this.redemption = document.querySelector('[data-component="redemption"]')

    // Question 1 (First Part) Select Functionality
    this.firstPartSelect.addEventListener('change', () => {
      this.element.classList.add('active')
      const valueLength = 20
      const value = this.firstPartSelect.value
      this.selectedBank = value
      document.getElementById('summary-bank').innerHTML = value
      const truncatedValue = value.substring(0, valueLength)
      this.createCookie('BankName', value, 0)
      if (value.length >= 20) {
        this.firstPartEmptySpan.innerHTML = truncatedValue + '...'
      } else {
        this.firstPartEmptySpan.innerHTML = truncatedValue
      }

      this.secondPart.classList.add('active')
      this.populateCards()
      this.populateCities()
    })

    // Question 1 (Second Part) Select Functionality
    this.secondPartSelect.addEventListener('change', () => {
      const valueLength = 23
      const value = this.secondPartSelect.value
      this.selectedCard = value
      document.getElementById('summary-card').innerHTML = value
      let bankResult
      banks.forEach(bank => {
        if (bank.bank === this.selectedBank) bankResult = bank
      })
      let cardResult
      bankResult.cards.forEach(card => {
        if (card.name === this.selectedCard) cardResult = card
      })
      document.querySelector('.percentage-bonus').querySelector('.amount').innerHTML = cardResult.totalBonus
      document.querySelector('.extra-bonus').innerHTML = cardResult.bonusFinePrint
      const truncatedValue = value.substring(0, valueLength)
      this.createCookie('CardName', value, 0)
      if (value.length >= 23) {
        this.secondPartEmptySpan.innerHTML = truncatedValue + '...'
      } else {
        this.secondPartEmptySpan.innerHTML = truncatedValue
      }
      document.getElementById('question-2').querySelector('.empty').innerHTML = ''
      document.getElementById('points').selectedIndex = 0
      document.getElementById('question-3').querySelector('.empty').innerHTML = ''
      document.getElementById('cities').selectedIndex = 0
      this.question1.classList.add('is-complete')
      this.question1.classList.remove('active')
      this.question2.classList.add('active')
      this.formWrapper.classList.add('question-1-complete')
      this.sectionHeader.classList.add('hidden')
      this.populatePoints()
    })

    // Points to Cookie
    this.element.querySelector('#points').addEventListener('change', event => {
      this.createCookie('Points', event.target.value, 0)
      this.selectedPoints = event.target.value
      document.getElementById('summary-points').innerHTML = event.target.value
      let b
      let c
      banks.forEach(bank => {
        if (bank.bank === this.selectedBank) b = bank
      })
      b.cards.forEach(card => {
        if (card.name === this.selectedCard) c = card
      })
      c.points.forEach(point => {
        if (point.bankPoints === this.selectedPoints) this.velocityPoints = point.velocityPoints
      })
    })

    // City to Cookie
    this.element.querySelector('#cities').addEventListener('change', event => {
      this.createCookie('City', event.target.value, 0)
      this.selectedPlace = event.target.value
    })

    // Populate Banks
    const bankSelect = this.element.querySelector('#bank')
    banks.map(result => {
      let bankSelectOption = this.createNode('option')
      bankSelectOption.value = `${result.bank}`
      bankSelectOption.innerHTML = `${result.bank}`
      this.append(bankSelect, bankSelectOption)
    })

    // Functionality for on change of dropdowns
    this.questions.forEach((element) => {
      const select = element.querySelector('select')
      const emptySpan = element.querySelector('.empty')
      const formWrapper = this.element.querySelector('.form-wrapper')
      select.addEventListener('change', () => {
        emptySpan.innerHTML = select.value
        element.classList.add('is-complete')
        element.classList.remove('active')
        if (element.id == 'question-2') {
          this.formWrapper.classList.add('question-2-complete')
          element.nextElementSibling.classList.add('active')
          document.getElementById('question-3').querySelector('.empty').innerHTML = ''
          document.getElementById('cities').selectedIndex = 0
        } else if (element.id == 'question-3') {
          this.formWrapper.classList.add('question-3-complete')
          this.calculateSubmitWrapper.classList.add('visible')
        }
      })
    })

    // Submit button Functionality
    this.calculateSubmitBtn.addEventListener('click', (event) => {
      event.preventDefault()
      if (
        document.getElementById('bank').selectedIndex === 0 ||
        document.getElementById('card').selectedIndex === 0 ||
        document.getElementById('points').selectedIndex === 0 ||
        document.getElementById('cities').selectedIndex === 0
      ) {
        if (!document.getElementById('form-error')) {
          let error = this.createNode('p')
          error.id = 'form-error'
          error.style.color = '#d6083b'
          error.style.margin = '1em 0'
          error.style.fontWeight = 800
          error.innerHTML = 'Please complete all fields'
          document.querySelector('.calculator-submit').appendChild(error)
        }
      } else {
        this.formInner.classList.add('hidden')
        this.populateResults()
        setTimeout(() => {
            this.formInner.style.display = 'none'
          }, 100
        )
        this.humorousLine.classList.add('visible')
        this.plane.classList.add('full')
        this.plane.addEventListener('transitionend', (event) => {
          this.redemption.classList.add('visible')
          document.body.classList.add('locked')
        })
      }
    })

  }

  // Populate Results
  populateResults() {
    let results = document.querySelector('.choices').queryAll('.choice')
    let r
    rewards.forEach(reward => {
      if (reward.velocityPoints === this.velocityPoints) r = reward.rewards
    })
    let p
    r.forEach(place => {
      if (place.originatingPlace === this.selectedPlace) p = place.displayOptions
    })
    results.forEach((result, index) => {
      if (p[index].type === 'Flight') {
        result.querySelector('img').src = `/content/dam/velocity/global/rewards_images/${p[index].destination.replace(/\s/g, '')}.png`
        result.querySelector('img').alt = `${p[index].destination.replace(/\s/g, '')}`
      } else {
        result.querySelector('img').src = `/content/dam/velocity/global/rewards_images/${p[index].type.replace(/\s/g, '')}.png`
        result.querySelector('img').alt = `${p[index].type.replace(/\s/g, '')}`
      }

      if (p[index].type === 'Flight' || (p[index].type === 'Upgrade')) {
        if(p[index].quantity.includes('Over halfway')) {
          result.querySelector('.offer').innerHTML = (p[index].quantity || '01') + ' ' + p[index].type
        } else {
          if (p[index].quantity > 1) {
            result.querySelector('.offer').innerHTML = (p[index].quantity || '01') + ' ' + 'x' + ' ' + p[index].type + 's'
          } else {
            result.querySelector('.offer').innerHTML = (p[index].quantity || '01') + ' ' + 'x' + ' ' + p[index].type
          }
        }
      } else {
        let quantity = ''
        if (p[index].quantity !== '') quantity = p[index].quantity
        result.querySelector('.offer').innerHTML = quantity + ' ' + 'x' + ' ' + p[index].type
      }

      if (p[index].type === 'Flight') result.querySelector('.type-of-offer').innerHTML = `From ${p[index].origin} To ${p[index].destination}`
      else result.querySelector('.type-of-offer').innerHTML = p[index].class

      if (p[index].type === 'Upgrade') result.querySelector('.to-and-from').innerHTML = `From ${p[index].origin} To ${p[index].destination}`
      else result.querySelector('.to-and-from').innerHTML = p[index].class

      if (p[index].type === 'Fuel' || (p[index].type === 'flight')) {
        result.querySelector('.to-and-from').innerHTML = ''
      }

      if (p[index].type === 'Fuel' && p[index].class === 'off') {
        result.querySelector('.offer').innerHTML = p[index].quantity
        result.querySelector('.type-of-offer').innerHTML = p[index].type
        result.querySelector('.to-and-from').innerHTML = ''
      }

      if (p[index].type === 'Flight Discount' && p[index].class === 'A Virgin Australia Flight') {
        result.querySelector('.offer').innerHTML = p[index].quantity
        result.querySelector('.to-and-from').innerHTML = ''
      }

      if (p[index].type === 'Lounge Pass' && p[index].class === 'Virgin Australia') {
        result.querySelector('.offer').innerHTML = p[index].class
        result.querySelector('.type-of-offer').innerHTML = p[index].type
        result.querySelector('.to-and-from').innerHTML = ''
      }

      if (p[index].type === 'Gift Card') {
        result.querySelector('.offer').innerHTML = `${p[index].quantity}  ${p[index].type}`
        result.querySelector('.type-of-offer').innerHTML = p[index].class
        result.querySelector('.to-and-from').innerHTML = ''
      }

      result.querySelector('.print').innerHTML = p[index].disclaimer.replace('[x]', p[index].airTaxes)

      let choices = document.querySelector('#terms-choices').queryAll('.choice-terms')
      choices.forEach((choice, i) => {
        choice.querySelector('.terms').innerHTML = p[i].shortTerms
      })
    })
  }

  // Populate Cards
  populateCards () {
    document.getElementById('card').options.length = 1
    let result
    banks.forEach(bank => {
      if (bank.bank === this.selectedBank) result = bank
    })
    result.cards.map(result => {
      let cardSelect = this.element.querySelector('#card')
      let cardSelectOption = this.createNode('option')
      cardSelectOption.value = `${result.name}`
      cardSelectOption.innerHTML = `${result.name}`
      this.append(cardSelect, cardSelectOption)
    })
    this.secondPartEmptySpan.innerHTML = ''
    document.getElementById('card').selectedIndex = 0
    document.getElementById('question-2').querySelector('.empty').innerHTML = ''
    document.getElementById('points').selectedIndex = 0
    document.getElementById('question-3').querySelector('.empty').innerHTML = ''
    document.getElementById('cities').selectedIndex = 0
  }

  populateCities () {
    document.getElementById('cities').options.length = 1
    let b
    banks.forEach(bank => {
      if (bank.bank === this.selectedBank) b = bank
    })
    b.cities.map(result => {
      let citySelect = this.element.querySelector('#cities')
      let citySelectOption = this.createNode('option')
      citySelectOption.value = `${result}`
      citySelectOption.innerHTML = `${result}`
      this.append(citySelect, citySelectOption)
    })
  }

  populatePoints () {
    document.getElementById('points').options.length = 1
    let b
    let c
    banks.forEach(bank => {
      if (bank.bank === this.selectedBank) b = bank
    })
    b.cards.forEach(card => {
      if (card.name === this.selectedCard) c = card
    })
    c.points.map(result => {
      let pointSelect = this.element.querySelector('#points')
      let pointSelectOption = this.createNode('option')
      pointSelectOption.value = `${result.bankPoints}`
      pointSelectOption.innerHTML = `${result.bankPoints}`
      this.append(pointSelect, pointSelectOption)
    })
    document.getElementById('minimum').innerHTML = `Your card has a minimum transfer amount of ${c.minimumPoints} points`
    if (b.bank == 'Bank of Melbourne' || b.bank == 'BankSA' || b.bank == 'St George Bank' || b.bank == 'Westpac') {
      document.getElementById('auto-redemption').style.display = 'block'
    } else {
      document.getElementById('auto-redemption').style.display = 'none'
    }
  }

  // Create node function
  createNode (element) {
    return document.createElement(element)
  }

  // Append function
  append (parent, el) {
    return parent.appendChild(el)
  }

  // Create cookie function
  createCookie(name, value, days) {
    var expires
    if (days) {
      var date = new Date()
      date.setTime(date.getTime()+(days*24*60*60*1000))
      expires = "; expires="+date.toGMTString()
    } else {
      expires = ""
    }
    document.cookie = name+"="+value+expires+"; path=/"
  }

  // Read cookie
  readCookie(name) {
    var nameEQ = name + "="
    var ca = document.cookie.split(';')
    for(var i=0;i < ca.length;i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1,c.length)
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length,c.length)
      }
    }
    return null
  }

}



// WEBPACK FOOTER //
// ./components/calculate-my-bonus/index.js